var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: { title: _vm.title, icon: "ti-agenda" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-alert",
                {
                  staticClass: "rounded-0",
                  attrs: { variant: "warning", show: true }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("message.adminContractPartnerDetails.warning")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c("admin-contract-partner-form", {
                    on: {
                      onCancel: _vm.cancel,
                      onSave: _vm.saveContractPartner
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05d75ffb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d75ffb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminContractPartnerDetails.vue
// module id = Vn/Z
// module chunks = 1